import FetchingPromptsPage from "./FetchingPromptsPage";
import { withRouter } from "react-router-dom";

export default withRouter(FetchingPromptsPage);
